import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import LanguageDetector from 'i18next-browser-languagedetector';

export const COMMON_NAMESPACE = 'common';
export const PROTOCOL_NAMESPACE = 'protocol';
export const SETTLEMENT_NAMESPACE = 'settlement';
export const DYNAMIC_NAMESPACE = 'dynamic';
export const SENDOUT_NAMESPACE = 'sendout';

const FALLBACK_LANGUAGE = 'no';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: FALLBACK_LANGUAGE,
    // eslint-disable-next-line no-undef
    debug: process.env.NODE_ENV !== 'production',
  });

export const loadFallbackBundles = async (
  locale: string,
  namespaces: string[],
  fetchBundle: (language: string) => Promise<any>,
) => {
  if (
    locale === FALLBACK_LANGUAGE ||
    namespaces.every((ns) => i18n.hasResourceBundle(FALLBACK_LANGUAGE, ns))
  ) {
    return;
  }
  const bundle = await fetchBundle(FALLBACK_LANGUAGE).catch(() => undefined);
  if (!bundle) return;
  namespaces.forEach((ns) =>
    i18n.addResourceBundle(FALLBACK_LANGUAGE, ns, bundle),
  );
};

export default i18n;
